import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react'

import { get } from 'lodash'

import { PortalLayout, CustomSelect, CustomInput, ActionButtons } from '../../components'
import BgImage from '../../../../assets/images/bg-report-form.png'
import FarmReportIcon from '../../../../assets/images/farm-report-icon.png'
import { api, request } from '../../../../util/handlerRequestUtil'

import './Styles.css'

const FormReport = ({ location, history }) => {
  const [materials, setMaterials] = useState([])
  const [materialsCheck, setMaterialsCheck] = useState([])
  const [material, setMaterial] = useState(undefined)
  const [check, setCheck] = useState(undefined)
  const [area, setArea] = useState(undefined)
  const [report, setReport] = useState({ fields: [] })

  useLayoutEffect(() => {
    const receivedReport = get(location, 'state.report')

    if (!receivedReport) {
      return history.push('/farmers/reports')
    }

    setReport(receivedReport)
  }, [])

  useEffect(() => {
    fetchMaterials()
  }, [])

  async function fetchMaterials() {
    const { items = [] } = await request(api.getMaterials({ ignorePagination: true }))

    const i2xMaterials = items.filter(({ technology }) => technology.toUpperCase() === 'I2X')

    const formattedMaterials = i2xMaterials.map((item) => ({
      ...item,
      id: item.name,
      description: item.name
    }))

    const formattedMaterialsCheck = items.map((item) => ({
      ...item,
      id: item.name,
      description: item.name,
      maturationGroup: item.maturationGroup
    }))

    setMaterials(formattedMaterials)
    setMaterialsCheck(formattedMaterialsCheck)
  }

  async function handleSubmit() {
    const [checkMaterial = {}] = materialsCheck.filter((item) => item.id === check)
    const [foundMaterial = {}] = materials.filter((item) => item.id === material)

    history.push({
      pathname: report.path,
      state: { material, check, area, materialName: foundMaterial.name, maturationGroup: checkMaterial.maturationGroup }
    })
  }

  const formIsInvalid = useMemo(() => {
    if (report.fields.includes('material') && !material) return true
    if (report.fields.includes('check') && !check) return true

    return report.fields.includes('area') && !area
  }, [report, material, check, area])

  return (
    <PortalLayout
      bgImage={BgImage}
      centerImage={FarmReportIcon}
      centerImageHeight="60px"
      title="Insira os dados para o relatório"
      subtitle={report.title}
    >
      <div className="form-report">
        <div className="content">
          <div className="form">
            <p className="title">Selecione os materiais</p>
            {report.fields.includes('material') && (
              <CustomSelect
                label="Material i2X"
                placeholder="Selecione um material"
                onChange={setMaterial}
                options={materials}
                value={material}
                required
              />
            )}

            {report.fields.includes('check') && (
              <CustomSelect
                label="Material check"
                placeholder="Selecione um material"
                onChange={setCheck}
                options={materialsCheck}
                value={check}
                required
              />
            )}

            {report.fields.includes('area') && (
              <CustomInput
                type="number"
                label="Área plantada (ha)"
                placeholder="Digite aqui"
                onChange={setArea}
                value={area}
                required
              />
            )}
          </div>

          <ActionButtons actionTitle="Avançar" disableAction={formIsInvalid} onClickAction={handleSubmit} />
        </div>
      </div>
    </PortalLayout>
  )
}

export default FormReport
